import { TrainingsSessionModalityEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type ModalityOption = {
  label: string
  value: TrainingsSessionModalityEnum
}

export const useModalities = () => {
  const modalityOptions: ModalityOption[] = [
    {
      label: i18n.t(
        'trainings.trainings_revamp.training_class.class_wizard.event_data_step.event_box.modality.options.hybrid'
      ),
      value: 'mixed',
    },
    {
      label: i18n.t(
        'trainings.trainings_revamp.training_class.class_wizard.event_data_step.event_box.modality.options.onsite'
      ),
      value: 'inperson',
    },
    {
      label: i18n.t(
        'trainings.trainings_revamp.training_class.class_wizard.event_data_step.event_box.modality.options.online'
      ),
      value: 'online',
    },
  ]
  return { modalityOptions }
}
